import React, { createContext, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchWhatsappPages,
  getWhatsappPageDetails,
} from "../Redux/Slice/Settings/WhatsappPageSlice/WhatsappPageSlice";
import PropTypes from "prop-types";
import { useSession } from "./SessionContext";
const WhatsappContext = createContext();

export const WhatsappProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { WhatsappPages, loading } = useSelector(getWhatsappPageDetails);
  const [whatsappPagesList, setWhatsappPagesList] = useState([]);
  const [instance, setInstance] = useState("");
  const [instanceId, setInstanceId] = useState(null);
  const { session } = useSession();

  const isLoggedIn = Boolean(session?.LoginId && session?.user);

  useEffect(() => {
    if (!isLoggedIn) return;

    dispatch(fetchWhatsappPages());
  }, [dispatch, isLoggedIn]);

  // useEffect(() => {
  //     dispatch(fetchWhatsappPages());
  // }, [dispatch]);

  // Filter connected pages and set default instance
  useEffect(() => {
    if (WhatsappPages && WhatsappPages.length > 0) {
      const connectedPages = WhatsappPages.filter(page => page.IsConnect);
      setWhatsappPagesList(connectedPages);
    }
  }, [WhatsappPages, instance]);
  const value = {
    whatsappPagesList,
    instance,
    instanceId,
    loading,
    setInstance,
    setInstanceId,
  };

  return <WhatsappContext.Provider value={value}>{children}</WhatsappContext.Provider>;
};
WhatsappProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
export const useWhatsapp = () => useContext(WhatsappContext);
